// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dashboard-component .dashboard-component .loading-chart{left:0;position:absolute;right:0;top:0;bottom:0}`, "",{"version":3,"sources":["webpack://./src/shared/components/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAGQ,wDACI,MAAA,CACA,iBAAA,CACA,OAAA,CACA,KAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
